export enum ValidationRule {
  REQUIRED = "Required",
  OPTIONAL = "Optional",
  HIDDEN = "Hidden"
}
